import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];
const KEY = "veridian-preloaded";

export default function Preloader() {
  const [show, setShow] = useState(() => !sessionStorage.getItem(KEY));

  useEffect(() => {
    if (!show) return;
    const t0 = setTimeout(() => window.__lenis?.stop(), 50);
    const t = setTimeout(() => {
      sessionStorage.setItem(KEY, "1");
      setShow(false);
      window.__lenis?.start();
    }, 2100);
    return () => {
      clearTimeout(t0);
      clearTimeout(t);
    };
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="preloader"
          className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-ink text-sand"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: EASE }}
          data-testid="site-preloader"
        >
          <motion.div
            exit={{ opacity: 0, y: -30 }}
            transition={{ duration: 0.4 }}
            className="flex flex-col items-center"
          >
            <div className="relative h-24 w-28 overflow-hidden">
              <motion.img
                src="/brand/mark.png"
                alt=""
                className="h-full w-full object-contain"
                initial={{ clipPath: "inset(100% 0 0 0)", scale: 0.9 }}
                animate={{ clipPath: "inset(0% 0 0 0)", scale: 1 }}
                transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
              />
            </div>
            <motion.img
              src="/brand/lockup-light.png"
              alt="Veridian Education Foundation"
              className="mt-8 h-8 w-auto"
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.9, ease: [0.22, 1, 0.36, 1] }}
            />
            <motion.p
              className="mt-6 text-[11px] font-semibold uppercase tracking-[0.4em] text-mintlight"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 1.3 }}
            >
              Connecting Knowledge
            </motion.p>
          </motion.div>
          <motion.div
            className="absolute bottom-0 left-0 h-[2px] bg-terra"
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            transition={{ duration: 1.9, ease: "linear" }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
